import {
  normalizeTipoParam,
  normalizePctWidths,
} from "./paramEruptivosColumns";

export function normalizeTipoFenomeno(str) {
  const norm = normalizeTipoParam(str);
  if (norm === "ondas de choque" || norm === "onda de choque") {
    return "onda de choque";
  }
  return norm;
}

export const FENOMENO_TIPOS_ORDER = [
  { norm: "sismos volcanicos", label: "Sismos volcánicos" },
  { norm: "deformacion", label: "Deformación" },
  { norm: "onda de choque", label: "Ondas de choque" },
  { norm: "rayo volcanico", label: "Rayo volcánico" },
  { norm: "incandescencia", label: "Incandescencia" },
];

export function compareFenomenoTipos(aNorm, bNorm) {
  const la = labelForTipoFenomeno(aNorm) || aNorm;
  const lb = labelForTipoFenomeno(bNorm) || bNorm;
  return la.localeCompare(lb, "es", { sensitivity: "base" });
}

export function labelForTipoFenomeno(tipoNorm) {
  return (
    FENOMENO_TIPOS_ORDER.find((t) => t.norm === tipoNorm)?.label ?? tipoNorm
  );
}

const imgCol = {
  key: "__imagenes",
  label: "",
  width: 32,
  align: "center",
  isImages: true,
};

const common = [
  { key: "__fuente", label: "Fuente", widthPct: 14, align: "center" },
  {
    key: "__reporte",
    label: "Reporte bibliográfico",
    widthPct: 28,
    align: "justify",
  },
];

function buildFenomenoColumns(cols) {
  return normalizePctWidths(cols.map((c) => ({ ...c })));
}

export function getFenomenoColumns(tipoNorm) {
  if (tipoNorm === "sismos volcanicos") {
    return buildFenomenoColumns([
      ...common,
      {
        key: "tipo_seniales_sismicas",
        label: "Tipo de señales sísmicas",
        align: "center",
        widthPct: 14,
      },
      {
        key: "magnitud",
        label: "Magnitud",
        align: "center",
        widthPct: 10,
      },
      {
        key: "profundidad",
        label: "Profundidad (km)",
        align: "center",
        widthPct: 10,
      },
      imgCol,
    ]);
  }

  if (tipoNorm === "deformacion") {
    return buildFenomenoColumns([
      ...common,
      {
        key: "tipo_deformacion",
        label: "Tipo de deformación",
        align: "center",
        widthPct: 14,
      },
      {
        key: "inclinacion",
        label: "Inclinación (µrad)",
        align: "center",
        widthPct: 12,
      },
      {
        key: "tasa_deformacion",
        label: "Tasa de deformación (mm/año, cm/año)",
        align: "center",
        widthPct: 16,
      },
      imgCol,
    ]);
  }

  if (tipoNorm === "onda de choque") {
    return buildFenomenoColumns([
      ...common,
      {
        key: "alcance_acustico",
        label: "Alcance acústico (km)",
        align: "center",
        widthPct: 12,
      },
      {
        key: "velocidad",
        label: "Velocidad (m/s)",
        align: "center",
        widthPct: 12,
      },
      {
        key: "numero_mach",
        label: "Número de Mach",
        align: "center",
        widthPct: 12,
      },
      {
        key: "sobrepresion",
        label: "Sobrepresión (Pa)",
        align: "center",
        widthPct: 12,
      },
      imgCol,
    ]);
  }

  if (tipoNorm === "rayo volcanico") {
    return buildFenomenoColumns([
      ...common,
      {
        key: "tipo_rayo_volcanico",
        label: "Tipo de rayo volcánico",
        align: "center",
        widthPct: 14,
      },
      {
        key: "tasa_destello_rayos",
        label: "Tasa de destello de rayos (min⁻¹)",
        align: "center",
        widthPct: 14,
      },
      {
        key: "corriente_maxima_descarga",
        label: "Corriente máxima de descarga (kA)",
        align: "center",
        widthPct: 14,
      },
      imgCol,
    ]);
  }

  if (tipoNorm === "incandescencia") {
    return buildFenomenoColumns([
      ...common,
      {
        key: "temperatura",
        label: "Temperatura (°C)",
        align: "center",
        widthPct: 12,
      },
      {
        key: "composicion_quimica",
        label: "Composición química",
        align: "justify",
        widthPct: 18,
      },
      imgCol,
    ]);
  }

  return buildFenomenoColumns([...common, imgCol]);
}

export function getFenomenoExcelColumnDefs(tipoNorm) {
  return getFenomenoColumns(tipoNorm)
    .filter((c) => c.key !== "__imagenes")
    .map((c) => ({
      key: c.key,
      label: c.key === "__fuente" ? "Fuente" : c.label,
      align: c.align,
    }));
}
